export default __webpack_public_path__ + "media/Objective/Objective-ExtraBold-Italic-87de33b09951d43e3d5562bc7f4ad310.woff2";